// src/components/DeletePatientButton.jsx
import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { CONFIG } from '../config/config';

const API_URL = (CONFIG.API_URL || '/api').replace(/\/+$/, '');

export default function DeletePatientButton({ patient, token, onDeleted, size = 18 }) {
  const [loading, setLoading] = useState(false);

  async function handleDelete(e) {
    e.stopPropagation();
    if (loading) return;

    const label = `${patient?.prenom || ''} ${String(patient?.nom || '').toUpperCase()}`.trim();
    if (!window.confirm(`Supprimer définitivement le patient « ${label || 'Sans nom'} » ?`)) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/passages/${encodeURIComponent(patient.id)}`, {
        method: 'DELETE',
        headers: { Authorization: token ? `Bearer ${token}` : '' },
      });

      // Succès “classique” OU tolérance : 204/404 => déjà supprimé -> on nettoie l’UI
      if (res.ok || res.status === 204 || res.status === 404) {
        onDeleted?.(patient.id);
        return;
      }

      const txt = await res.text().catch(() => '');
      throw new Error(`DELETE failed${txt ? ` – ${txt}` : ''}`);
    } catch (e) {
      console.error('delete patient error', e);
      alert('Suppression impossible.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      title="Supprimer"
      aria-label="Supprimer"
      onClick={handleDelete}
      className="rounded p-1 hover:bg-red-50 text-red-700"
    >
      <Trash2 size={size} className={loading ? 'opacity-50' : ''} />
    </button>
  );
}
